import { USER_BALANCE_CONFIG } from "../../config/api";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../shared/popup/popup.component";
import * as i3 from "../loader.service";
var UserBalanceService = /** @class */ (function () {
    function UserBalanceService(http, popupComponent, loaderService) {
        this.http = http;
        this.popupComponent = popupComponent;
        this.loaderService = loaderService;
        this.entries = 0;
        this.winnings = 0;
        this.gameBalance = 0;
        this.showBalanceLoader = false;
        this.config = USER_BALANCE_CONFIG;
    }
    UserBalanceService.prototype.getBalance = function () {
        //this.loaderService.show();
        return this.http.post(this.config.getBalance, {});
    };
    UserBalanceService.prototype.updateBalance = function (entries, winnings) {
        this.entries = entries;
        this.winnings = winnings;
    };
    UserBalanceService.prototype.updateGameBalance = function (balance) {
        this.gameBalance = balance;
    };
    UserBalanceService.prototype.getGameBalanceLoaderState = function () {
        return this.showBalanceLoader;
    };
    UserBalanceService.prototype.getEntries = function () {
        return Number(this.entries).toFixed(0);
    };
    UserBalanceService.prototype.getWinnings = function () {
        return Number(this.winnings).toFixed(0);
    };
    UserBalanceService.prototype.getGameBalance = function () {
        return this.gameBalance;
    };
    UserBalanceService.prototype.increaseBalance = function (amount, gameProviderId) {
        //this.loaderService.show();
        return this.http.post(this.config.increaseBalance, { amount: amount, gameProviderId: gameProviderId });
    };
    UserBalanceService.prototype.redeem = function (gameProviderId, amount) {
        // this.loaderService.show();
        return this.http.post(this.config.redeem, { gameProviderId: gameProviderId, amount: amount });
    };
    UserBalanceService.prototype.withdraw = function (gameProviderId, amount) {
        //this.loaderService.show();
        return this.http.post(this.config.withdraw, { gameProviderId: gameProviderId, amount: amount });
    };
    UserBalanceService.prototype.getGameBalanceRequest = function (id) {
        //this.loaderService.show();
        return this.http.post(this.config.getGameBalance, { id: id });
    };
    UserBalanceService.prototype.initGameBalanceRequest = function (id) {
        var _this = this;
        this.showBalanceLoader = true;
        this.getGameBalanceRequest(id).subscribe(function (data) {
            try {
                if (data.status) {
                    _this.updateGameBalance(data.availableBalance);
                }
                else {
                    _this.popupComponent.showPopupError({ text: data.message });
                }
                _this.showBalanceLoader = false;
            }
            catch (e) {
                _this.loaderService.hideAndShowTryAgain();
                _this.showBalanceLoader = false;
            }
        }, function () {
            _this.loaderService.hideAndShowTryAgain();
            _this.showBalanceLoader = false;
        }, function () {
            _this.loaderService.hide();
            _this.showBalanceLoader = false;
        });
    };
    UserBalanceService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserBalanceService_Factory() { return new UserBalanceService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.PopupComponent), i0.ɵɵinject(i3.LoaderService)); }, token: UserBalanceService, providedIn: "root" });
    return UserBalanceService;
}());
export { UserBalanceService };
